<template>
  <Popup :width="width" :margin="margin" :radiusType="radiusType" :closePopupEvent="closePopup">
    <div class="about" slot="component">
      <div class="about-images">
        <!-- <img
          v-if="providerUniqueId === 'net54321'"
          class="about-images-net5-logo"
          src="@/assets/icons/Net5.svg"
          alt="net5_logo"
        />
        <img
          v-else-if="providerUniqueId === 'z01x1wPo'"
          class="about-images-vlive-logo"
          src="@/assets/icons/nammaflix_logo.png"
          alt
        />-->
        <img class="about-images-noorPlay_logo" src="@/assets/icons/ultrawhite.png" alt />
        <!-- <img v-else class="about-images-vlive-logo" src="@/assets/icons/log.svg" alt /> -->
        <!-- <img class="about-images-vlive-title" src="@/assets/icons/text.svg" alt /> -->
        <!-- <p class="about-images-version">V1.0.1</p> -->
      </div>
      <div class="about-description">
        <p
          class="about-description-paragraph"
        >{{ localDisplayLang === 'ml' ? appConfig.providerDetails.aboutText.ar : appConfig.providerDetails.aboutText.default }}</p>
      </div>
      <div class="about-social">
        <p class="about-social-follow">{{ $t('follow us') }}</p>
        <div class="about-social-icons">
          <a
            :href="appConfig.providerDetails.social.facebook"
            target="_blank"
            rel="noopener"
            aria-label="facebook link"
          >
            <img src="@/assets/icons/newfb.svg" alt="facebook_img" />
          </a>
          <a
            :href="appConfig.providerDetails.social.instagram"
            target="_blank"
            rel="noopener"
            aria-label="instagram link"
          >
            <img src="@/assets/icons/newinsta.svg" alt="instagram_img" />
          </a>
          <!-- <a
            :href="appConfig.providerDetails.social.twitter"
            target="_blank"
            rel="noopener"
            aria-label="twitter link"
          >
            <img src="@/assets/icons/newtwitter.svg" alt="twitter_img" />
          </a> -->
          <!-- <a
            :href="appConfig.providerDetails.social.pinterest"
            target="_blank"
            rel="noopener"
            aria-label="pinterest link"
          >
            <img src="@/assets/icons/newpinterest.svg" alt="pinterest_img" />
          </a>-->
          <a
            :href="appConfig.providerDetails.social.youtube"
            target="_blank"
            rel="noopener"
            aria-label="pinterest link"
          >
            <img src="@/assets/icons/youtube.svg" alt="youtube" />
          </a>
        </div>
      </div>
      <div class="about-app-share">
        <button
          class="button-primary"
          :class="[providerUniqueId === 'z01x1wPo' ? 'primary-nammaflix-button' : 'primary-net5-button']"
          @click="shareApp"
        >{{ $t('share the app') }}</button>
      </div>
      <p style="text-align: center; color: white; font-size: 12px;margin-top: 15px;">v2.0.17</p>
      <div class="about-policy-links">


        <ul style="display: flex;">
  
          <li tabindex="1" class="text" @click="showTermsOfUse">
            <!-- <router-link tabindex="1" class="text" to="/termsofuse"> -->
              {{ $t("terms of use") }}
            <!-- </router-link> -->
          </li>

          <li tabindex="1"  class="text" @click="showPrivacyPolicy">
              <!-- <router-link tabindex="1"  class="text" to="/PrivacyPolicy"> -->
              {{ $t("privacy policy") }}
            <!-- </router-link> -->
          </li>

        </ul>
        
        
        <!-- <router-link to="/TermsOfUse">
          <p @click="closeAbout">Terms Of Use</p>
        </router-link>
        <router-link to="/PrivacyPolicy">
          <p @click="closeAbout">Privacy Policy</p>
        </router-link>-->
        <!-- <router-link :to="localDisplayLang === 'ara' ? '/ar/TermsOfUse' : '/en/TermsOfUse'">
          <p>
            {{ $t('terms of use') }}
          </p>
        </router-link> -->
						<!-- <a
              class="text"
              :href="[localDisplayLang === 'ara' ? appConfig.providerDetails.termsConditionsUrl.ar : appConfig.providerDetails.termsConditionsUrl.default ]"
              target="_blank"
            >{{ $t('terms of use') }}</a>
 						<a
              class="text"
              :href="[localDisplayLang === 'ara' ? appConfig.providerDetails.privacyPolicyUrl.ar : appConfig.providerDetails.termsConditionsUrl.default ]"
              target="_blank"
            >{{ $t('privacy policy') }}</a> -->
        <!-- <router-link :to="localDisplayLang === 'ara' ? 'https://www.ultraindia.com/privacy' : 'https://www.ultraindia.com/privacy'">
          <p>
            {{ $t('privacy policy') }}
          </p>
        </router-link> -->
      </div>
    </div>
  </Popup>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/eventBus";
import { _providerId } from "@/provider-config.js";
import Utility from "@/mixins/Utility.js";

export default {
  props: {
    closePopup: {
      type: Function
    }
  },
  data() {
    return {
      width: "50%",
      margin: "",
      radiusType: "full",
      providerUniqueId: _providerId,
      localDisplayLang: null
    };
  },
  computed: {
    ...mapGetters(["appConfig", "getRtl"])
  },
  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");

    //checking for change of language in local storage value
    eventBus.$on("check-local-storage", data => {
      this.localDisplayLang = data;
    });
    //setting margin for userauth popup based on screen width.
    if (screen.width < 576) {
      this.margin = "45% auto";
    } else {
      this.margin = "10% auto";
    }
  },
  methods: {
    closeAbout() {
      this.closePopup();
    },
    shareApp() {
      eventBus.$emit("show-share-app-popup", true);
    },
    showTermsOfUse() {
      let currentLanguage = this.getCurrentLanguageUrlBase();
      if(!this.isActiveTerms){
        return;
      }
      this.$router.push({name: 'termsofuse', params: {lang: currentLanguage}});

    },
    showPrivacyPolicy() {
      let currentLanguage = this.getCurrentLanguageUrlBase();
      if(!this.isActivePrivacy){
        return;
      }
      this.$router.push({name: 'privacypolicy', params: {lang: currentLanguage}});

    },
  },
  components: {
    Popup: () =>
      import(/* webpackChunkName: "Popup" */ "@/components/Slots/Popup.vue")
  },
  mixins: [Utility],
};
</script>

<style lang="scss">
@import "@/sass/_variables.scss";
@import "./AboutUs.scss"
</style>
